//messages.js;

export default {
  general: 'כללי',
  overview: 'סקירה כללית',
  customizer: 'התאמה אישית',
  features: 'מאפיינים',
  components: 'רכיבים',
  applications: 'יישומים',
  salesAndVisitStats: 'מכירות & מבקר נתונים סטטיסטיים',
  orderAndProjectStats: 'סדר פרוייקטים סטטיסטיקה',
  fitnessStats: 'סטטיסטיקת כושר',
  supportAndUsefulWidgets: 'תמיכה & יישומון שימושי',
  dashboard: 'לוּחַ מַחווָנִים',
  dashboardOverview: 'סקירה כללית של מרכז השליטה',
  dashboardv1: 'לוח המחוונים V1',
  dashboardv2: 'לוח המחוונים V2',
  widgets: "ווידג'טים",
  horizontalMenu: 'תפריט אופקי',
  pages: 'דפים',
  gallery: 'גלריה',
  pricing1: 'תמחור 1',
  pricing2: 'תמחור 2',
  blank: 'רֵיק',
  session: 'מוֹשָׁב',
  signUp1: 'הרשמה 1',
  signUp2: 'הרשמה 2',
  login1: 'התחברות 1',
  login2: 'התחברות 2',
  lockScreen: 'מסך נעילה',
  uiElements: 'אלמנטים של ממשק משתמש',
  buttons: 'כפתורים',
  cards: 'כרטיסים',
  checkbox: 'תיבת סימון',
  carousel: 'קרוסלה',
  chips: "צ'יפס",
  datepicker: 'תאריך',
  dialog: 'דיאלוג',
  grid: 'רֶשֶׁת',
  input: 'קֶלֶט',
  list: 'רשימה',
  menu: 'תַפרִיט',
  progress: 'התקדמות',
  radio: 'רָדִיוֹ',
  select: 'בחר',
  slider: 'מחוון',
  snackbar: 'סנקבר',
  tabs: 'כרטיסיות',
  toolbar: 'סרגל כלים',
  tooltip: 'הסבר קצר',
  timepicker: 'זמן',
  forms: 'טפסים',
  formValidation: 'אימות טופס',
  stepper: 'צעד',
  charts: 'תרשימים',
  vueChartjs: 'Vue Chartjs',
  vueEcharts: 'Vue Echarts',
  icons: 'סמלים',
  themify: 'תודיע',
  material: 'חוֹמֶר',
  tables: 'טבלאות',
  standard: 'תֶקֶן',
  slots: 'חריצים',
  selectable: 'ניתן לבחירה',
  searchRow: 'חפש שורה',
  maps: 'מפות',
  googleMaps: 'גוגל מפות',
  leafletMaps: 'מפות עלים',
  jvectorMap: 'מפת JVC',
  inbox: 'תיבת הדואר הנכנס',
  users: 'משתמשים',
  userProfile: 'פרופיל משתמש',
  usersList: 'רשימת משתמשים',
  calendar: 'לוּחַ שָׁנָה',
  editor: 'עוֹרֵך',
  quillEditor: 'עורך',
  wYSIWYG: 'WYSIWYG',
  vue2Dragula: 'דראגולה',
  dragAndDrop: 'גרור ושחרר',
  vueDraggable: 'Vue Draggable',
  draggableResizeable: 'Draggable Resizeable',
  chat: 'לְשׂוֹחֵחַ',
  todo: 'לעשות',
  modules: 'מודולים',
  user: 'מִשׁתַמֵשׁ',
  miscellaneous: 'שונות',
  promo: 'פרומו',
  connections: 'קשרים',
  follow: 'לעקוב אחר',
  unfollow: 'לעקוב',
  basicValidation: 'אימות בסיסי',
  validationWithSubmitAndclear: 'אימות עם שלח & ברור',
  submit: 'שלח',
  clear: 'ברור',
  step1: 'שלב 1',
  step2: 'שלב 2',
  step3: 'שלב 3',
  continue: 'לְהַמשִׁיך',
  cancel: 'לְבַטֵל',
  totalEarnings: 'סך ההכנסות',
  onlineRevenue: 'הכנסות מקוונות',
  offlineRevenue: 'הכנסה לא מקוונת',
  marketingExpenses: 'הוצאות שיווק',
  newCustomers: 'לקוחות חדשים',
  visitAndSalesStatistics: 'סטטיסטיקות מכירות ומכירות',
  collapse: 'הִתמוֹטְטוּת',
  reload: 'לִטעוֹן מִחָדָשׁ',
  close: 'לִסְגוֹר',
  bandwidthUsage: 'שימוש ברוחב פס',
  shoppingCart: 'עגלת קניות',
  totalDownloads: 'סה"כ הורדות',
  productSales: 'מכירת מוצרים',
  projectStatus: 'סטטוס הפרויקט',
  averageSteps: 'צעדים ממוצעים',
  todaysDistance: "המרחק של היום",
  todaysStep: "השלב של היום",
  todaysGoal: "המטרה של היום",
  calories: 'קלוריות',
  weeklySummary:'סיכום שבועי',
  supportTickets: 'תמיכה כרטיסים',
  todoList: 'רשימת מטלות',
  newsletterCampaign: 'מסע פרסום עלון',
  currentVisitors: 'מבקרים נוכחיים',
  newMembers: 'חברים חדשים',
  addNewBlog: 'הוסף בלוג חדש',
  add: 'לְהוֹסִיף',
  logOut: 'להתנתק',
  totalAppMemory: 'סה"כ זיכרון יישומים',
  totalMemoryUsed: 'סה"כ זיכרון בשימוש',
  unreadMail: '12 דואר שלא נקרא',
  feedback: 'מָשׁוֹב',
  flatButton: 'לחצן שטוח',
  raisedButton: 'לחצן גויס',
  gradientButton: 'כפתור הדרגתי',
  buttonDropdownVariants: 'לחצן הנפתחת',
  buttonToggle: 'לחצן',
  icon: 'סמל',
  normal: 'נוֹרמָלִי',
  disabled: 'נָכֶה',
  floating: 'צָף',
  loaders: 'מעמיסים',
  sizing: 'שינוי גודל',
  outline: 'מתווה',
  round: 'עָגוֹל',
  block: 'לַחסוֹם',
  search: 'לחפש',
  checkboxesBoolean: 'תיבות סימון בוליאניות',
  checkboxesArray: 'תיבות סימון',
  checkboxesStates: 'תיבות סימון - מדינות',
  checkboxesColors: 'תיבות סימון - צבעים',
  switches: 'מתגים',
  default: 'Défaut',
  customTransition: 'מעבר מותאם אישית',
  customDelimiter: 'תיחום מותאם אישית',
  hideControls: 'הסתר פקדים',
  hideDelimiters: 'הסתר מפרידים',
  colored: 'צבעוני',
  label: 'תווית',
  closeable: 'סגור',
  datePickerHorizontal: 'בורר תאריך אופקי',
  datePickerVertical: 'תאריך בורר אנכי',
  datePickersInDialogAndMenu: 'תאריך בוררים בדיאלוג ותפריט',
  datePickersWithModal: 'תאריך בוררים עם מודאלי',
  datePickersFormattingDate: 'תאריך בורר - תאריך עיצוב',
  simpleDialogs: 'דיאלוגים פשוטים',
  withoutActivator: 'ללא Activator',
  scrollable: 'גלילה',
  listOfAllMaterialIcons: 'רשימת כל סמלים חומר',
  arrowsAndDirectionsIcons: 'חצים וסמלי כיוון',
  webAppIcons: 'סמלי אפליקציות אינטרנט',
  CONTROLICONS: 'בקרת סמלים',
  TEXTEDITOR: 'עורך טקסט',
  LAYOUTICONS: 'פריסת סמלים',
  BRANDICONS: 'סמל מותג',
  newClients: 'צפיות בדף',
  recurringClients: 'לקוחות חוזרים',
  bounceRate: 'קצב הקפיצה',
  pageViews: 'צפיות בדף',
  usefulWidgets: "ווידג'טים שימושיים",
  sale: 'מְכִירָה',
  sales: 'מכירות',
  invoices: 'חשבוניות',
  referrals: 'הפניות',
  serverLoad: 'טען שרת',
  recentSale: 'בודות',
  supportRequest: 'בקשת תמיכה',
  productSale: 'מכירת מוצר',
  viewAll: 'צפה בהכל',
  barChart: 'טבלת עמודות',
  polarAreaChart: 'תרשים אזור פולאר',
  lineChart: 'תרשים שורה',
  radarChart: 'תרשים מכ"ם',
  doughnutChart: 'תרשים סופגניות',
  bubbleChart: 'תרשים הבועה',
  gradientLineChart: 'תרשים קווי צבע',
  pieChart: 'תרשים עוגה',
  funnelChart: 'תרשים משפך',
  loginNow: 'התחבר עכשיו',
  createAccount: 'צור חשבון',
  termsOfService: 'תנאי השירות',
  bySigningUpYouAgreeTo: 'על ידי ההרשמה אתה מסכים',
  loginToAdmin: 'כניסה למנהל',
  enterUsernameAndPasswordToAccessControlPanelOf: 'הזן שם משתמש וסיסמה כדי לגשת ללוח הבקרה של',
  havingAnAccount: 'יש לך חשבון?',
  quickLinks: 'קישורים מהירים',
  plans: 'תוכניות',
  chooseThePlanThatWorksForYou: 'בחר את התוכנית המתאימה לך.',
  monthly: 'יַרחוֹן',
  yearlyGet2MonthExtra: 'שנתי (לקבל תוספת חודשיים)',
  basic: 'בסיסי',
  pro: 'מִקצוֹעָן',
  advanced: 'מִתקַדֵם',
  basicFree: 'בסיסי חינם',
  startToBasic: 'התחל בסיסיים',
  upgradeToPro: 'שדרוג לפרו.',
  upgradeToAdvance: 'שדרג מראש',
  comparePlans: 'השווה תוכניות',
  frequentlyAskedQuestions: 'שאלות נפוצות',
  defaultInput: 'ברירת מחדל קלט',
  activator: 'Activator',
  hover: 'לְרַחֵף',
  menus: 'תפריטים',
  indeterminate: 'לֹא קָבוּעַ',
  sizeAndWidth: 'גודל ורוחב',
  rotate: 'לְסוֹבֵב',
  determinate: 'קבעו',
  buffer: 'בַּלָם',
  radiosDefault: 'רדיו ברירת מחדל',
  radiosDirectionRow: 'רדיו כיוון שורה',
  radiosDirectionColumn: 'עמודות כיוון רדיו',
  radiosColors: 'מכשירי רדיו - צבעים',
  switchesColors: 'מתגים - צבעים',
  continuous: 'רָצִיף',
  discrete: 'נִבדָל',
  customColors: 'צבעים מותאמים אישית',
  editableNumericValue: 'ערך מספרי הניתן לעריכה',
  contextualSnackbar: 'מזנון קונטקסטואלי',
  showSnackbar: 'הצג את Snackbar',
  centeredTabs: 'כרטיסיות מרוכזות',
  toolbarTabs: 'כרטיסיות סרגל הכלים',
  theDefaultColorToolbar: 'סרגל הכלים של ברירת המחדל של צבע',
  appBar: 'בר יישומים',
  appBarWithExtension: 'בר App עם הרחבה',
  visibility: 'רְאוּת',
  top: 'חלק עליון',
  right: 'ימין',
  bottom: 'תַחתִית',
  left: 'שמאלה',
  toggle: 'לְמַתֵג',
  timePicker: 'בורר זמן',
  timePickerInDialogAndMenu: 'זמן בורר - בדיאלוג תפריט',
  itemsAndHeaders: 'פריטים וכותרות',
  selectableRows: 'שורות לבחירה',
  headerCell: 'תא כותרת',
  expand: 'לְהַרְחִיב',
  recentChat: "צ'אט אחרונים",
  previousChats: "צ'אטים קודמים",
  addNewItems: 'הוסף פריטים חדשים',
  addToDo: 'הוסף לעשות',
  yes: 'כן',
  ok: 'בסדר',
  activeUsers: 'משתמשים פעילים',
  addNew: 'הוסף חדש',
  readMore: 'קרא עוד',
  assignNow: 'הקצה עכשיו',
  totalRequest: 'סה"כ בקשה',
  new: 'חָדָשׁ',
  pending: 'ממתין ל',
  update: 'עדכון',
  updated10MinAgo: 'עודכן לפני 10 דקות',
  addNewCustomer: 'הוסף לקוח חדש',
  name: 'שֵׁם',
  email: 'אֶלֶקטרוֹנִי',
  editMember: 'ערוך חבר',
  scheduleDate: 'תאריך תזמון',
  title: 'כותרת',
  newEmails: 'הודעות דוא"ל חדשות',
  newEmail: 'מייל חדש',
  employeePayroll: 'שכר שכר',
  forMostOfTheUsers: 'עבור רוב המשתמשים',
  choosePlan: 'בחר תוכנית',
  mega: 'מגה',
  master: 'לִשְׁלוֹט',
  forDeveloper: 'I Developer',
  forLargeEnterprises: 'עבור ארגונים גדולים',
  composeEmail: 'כתוב מייל אלקטרוני',
  mailboxes: 'תיבות דואר',
  folders: 'תיקיות',
  settings: 'הגדרות',
  inbox5: 'תיבת דואר נכנס (5)',
  draft: 'טְיוּטָה',
  starred: 'כיכב',
  sentMessages: 'הודעות שנשלחו',
  spam: 'ספאם',
  delete: 'לִמְחוֹק',
  work: 'עֲבוֹדָה',
  personal: 'אישי',
  manageFolders: 'ניהול תיקיות',
  contacts: 'אנשי קשר',
  themeOptions: 'אפשרויות ערכת נושא',
  darkMode: 'מצב כהה',
  collapseSidebar: 'כווץ את הסרגל הצידי',
  boxLayout: 'פריסת תיבה',
  rtlLayout: 'פריסת Rtl',
  backgroundImage: 'תמונת רקע',
  sidebarFilters: 'מסננים לסרגל הצד',
  danger: 'וָרוֹד',
  primary: 'יְסוֹדִי',
  warning: 'אַזהָרָה',
  success: 'הַצלָחָה',
  info: 'סָגוֹל',
  dailySales: 'מכירות יומיות',
  trafficChannel: 'ערוץ תעבורה',
  campaignPerformance: 'ביצועי מסע פרסום',
  goToCampaign: 'עבור אל מסע פרסום',
  fullScreen: 'מסך מלא',
  ecommerce: 'מסחר אלקטרוני',
  shop: 'לִקְנוֹת',
  cart: 'עֲגָלָה',
  total: 'סה"כ',
  totalPrice: 'מחיר סופי',
  viewCart: 'צפה בסל',
  checkout: 'לבדוק',
  apply: 'להגיש מועמדות',
  noItemsFound: 'לא נמצאו פריטים',
  billingDetails: 'פרטי תשלום',
  placeOrder: 'בצע הזמנה',
  addNewCard: 'הוסף כרטיס חדש',
  devicesShare: 'שיתוף התקנים',
  customerOverview: 'סקירה כללית על לקוחות',
  reviews: 'ביקורות',
  weeklySales: 'מכירות שבועיות',
  recentOrders: 'הזמנות אחרונות',
  categorySales: 'קטגוריה מכירות',
  topSelling: 'מכירת למעלה',
  social: 'חֶברָתִי',
  newPost: 'פוסט חדש',
  publish: 'פרסם',
  webAnalytics: 'ניתוחי רשת',
  magazine: 'מגזין',
  editUser: 'ערוך משתמש',
  addNewUser: 'הוסף משתמש חדש',
  dark: 'אפל',
  light: 'אוֹר',
  recentUsers: 'משתמשים אחרונים',
  activityAroundWorld: 'פעילות ברחבי העולם',
  adsIncome: 'הכנסות ממודעות',
  recentComments: 'תגובות אחרונות',
  recentNotifications: 'הודעות אחרונות',
  messages: 'הודעות',
  edit: 'לַעֲרוֹך',
  topAuthors: 'מחברים מובילים',
  marketingCampaign: 'קמפיין שיווקי',
  articles: 'מאמרים',
  websiteTraffic: 'התנועה באתר',
  agency: 'סוֹכְנוּת',
  recent: 'לאחרונה',
  trending: 'מגמות',
  totalPageViews: 'סה"כ תצוגות דף',
  impressions: 'הופעות',
  deviceSeparations: 'הפרדות התקן',
  browserStatics: 'סטטיסטיקת דפדפן',
  totalDownloading: 'סה"כ הורדה',
  notifications: 'התראות',
  totalBookmarked: 'סה"כ סימניות',
  itemsDownloads: 'פריטים הורדות',
  itemsUploaded: 'פריטים שהועלו',
  totalAnalytics: 'סה"כ Analytics',
  hotKeywords: 'מילות מפתח חמות',
  MaleUsers: 'משתמשים זכר',
  serverStatus: 'מצב שרת',
  purchaseVuely: 'רכישה Vuely',
  letsGetInTouch: 'מאפשר ליצור קשר',
  maleUsers: 'משתמשים זכר',
  femaleUsers: 'משתמשי נקבה',
  androidUsers: 'משתמשי Android',
  iOSUsers: 'משתמשי iOS',
  advance: 'לְקַדֵם',
  routerAnimation: 'אנימציה נתב',
  salesAndEarning: 'מכירות להרוויח',
  netProfit: 'רווח נקי',
  totalExpences: 'סך ההוצאות',
  photos: 'תמונות',
  adCampaignPerfomance: 'ביצועי מסע פרסום של מודעות',
  profitShare: 'חלוקת רווחים',
  topSellingTheme: 'נושא מוכר למעלה',
  newRequest: 'בקשה חדשה',
  followers: 'עוקבים',
  mailbox: 'תיבת דואר',
  sent: 'נשלח',
  birthdays: 'ימי הולדת',
  events: 'אירועים',
  newsletter: 'עלון',
  lastMonth: 'חודש שעבר',
  allTime: 'כל הזמן',
  composeNewEmail: 'כתוב דוא"ל חדש',
  activity: 'פעילות',
  message: 'הוֹדָעָה',
  selectTheme: 'בחר ערכת נושא',
  continueShopping: 'המשך בקניות',
  proceedToCheckout: 'התקדם לנקודת הביקורת',
  headerFilters: 'מסננים כותרת',
  blog: "בלוג",
  signUp: "הירשם",
  login: "התחברות",
  news: "חדשות",
  topHeadlines: "כותרות עליונות",
  visitors: "מבקרים",
  subscribers: "מנויים",
  twitterFeeds: "עדכוני Twitter",
  extensions: "תוספים",
  imageCropper: "תמונה קרופר",
  videoPlayer: "נגן וידאוr",
  dropzone: "איזור נפילה ",
  baseConfig: "תצורת Base",
  audioTrackAndPlaysInline: "אודיו מסלול ומנגן בשורה",
  hlsLive: "HLS Live",
  forgotPassword: "שכחת את הסיסמא",
  resetPassword: "לאפס את הסיסמה",
  backToSignIn: "חזרה כדי להיכנס",
  enterYourEmailToSendYouAResetLink: "הזן את האימייל שלך כדי לשלוח לך קישור איפוס",
  pleaseEnterYourPasswordToReset: "הזן את הסיסמה שלך לאיפוס",
  saas: "ס.א.ס.",
  overallTrafficStatus: "מצב התנועה הכולל",
  projectManagement: "ניהול פרוייקט",
  projectTaskManagement: "ניהול משימות פרוייקט",
  totalSales: 'סה"כ מכירות',
  simple: "פָּשׁוּט",
  transitions: "מעברים",
  tax: "מַס",
  expenses: "הוצאות",
  images: "תמונות",
  ratings: "דירוגים",
  containAndCover: 'מכילים כיסוי',
  height: 'גוֹבַה',
  fixedRatio: 'יחס קבוע',
  gradients: 'גרדיאנטים',
  sizeVariants: 'גודל משתנה',
  newIcons: 'סמלים חדשים',
  webApplication: 'אפליקציית רשת',
  person: 'אדם',
  file: 'קוֹבֶץ',
  comment: 'תגובה',
  form: 'טופס',
  hardware: 'חוּמרָה',
  directional: 'כִּוּוּנִי',
  mapAliases: 'מפה (כינויים)',
  dateAndTime: 'תאריך ושעה'
}
